import React from 'react';
interface ArrowButtonProps {
  direction: 'left' | 'right';
  onClick?: () => void;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
const sizeMap = {
  sm: {
    btn: 'w-[30px] h-[30px] lg:w-[50px] lg:h-[50px]',
    text: 'text-[14px] lg:text-[22px]'
  },
  md: {
    btn: 'w-[38px] h-[38px] lg:w-[75px] lg:h-[75px]',
    text: 'text-[16px] lg:text-[38px]'
  },
  lg: {
    btn: 'w-[38px] h-[38px] lg:w-[75px] lg:h-[75px]',
    text: 'text-[16px] lg:text-[38px]'
  }
};
export function ArrowButton({
  direction,
  onClick,
  size = 'md',
  className = ''
}: ArrowButtonProps) {
  const s = sizeMap[size];
  return <button onClick={onClick} className={`has-radius bg-white flex items-center justify-center hover:bg-gray-50 z-10 transition-colors ${s.btn} ${className}`} style={{
    borderRadius: '50%'
  }} data-id="element-18">
      <span style={{
      color: '#000000'
    }} className={`font-bold ${s.text} leading-none`} data-id="element-19">
        {direction === 'left' ? '\u003C' : '\u003E'}
      </span>
    </button>;
}